import { styled, Button } from '@orthly/ui-primitives';

/** 24 px tall button, good for use with the `ghost` variant. */
export const NarrowButton = styled(Button)({ height: 24, padding: `0px 4px`, margin: '0px -4px', justifySelf: 'end' });
